export * from './set-page-title';
export * from './error.utils';
export * from './filter.utils';
export * from './titlecase.utils';
export * from './patterns';
export * from './phone.utils';
export * from './amount.utils';
export * from './limit.utils';
export * from './currency.utils';
export * from './exception-management-utils';
export * from './state-list-utils';
export * from './solution-utils';
export * from './document.utils';
export * from './business-account.utils';

export const formatLegalId = (taxId?: string) => {
  if (!taxId) {
    return undefined;
  }

  return `${taxId.slice(0, 2)}-${taxId.slice(2)}`;
};

export const countryCodeFormat = (countryCode?: string) => {
  if (!countryCode) {
    return undefined;
  }

  switch (countryCode) {
    case 'US':
      return 'USA';
    case 'AZ':
      return 'AZE';
    default:
      return countryCode;
  }
};

export const systemTimeZone = `${Intl.DateTimeFormat().resolvedOptions().timeZone}`;

export const cleanMaskedAccountNumber = (maskedAccountNumber: string | undefined): string => {
  if (!maskedAccountNumber) {
    return '';
  }
  return maskedAccountNumber.replace(/[\s*]/g, '');
};

export const formatSocialSecurityNumber = (socialId: string | undefined) => {
  if (!socialId) return undefined;

  if (socialId.length === 4) {
    return socialId;
  }

  return `${socialId.slice(0, 3)}-${socialId.slice(3, 5)}-${socialId.slice(5, 9)}`;
};
